import { render, staticRenderFns } from "./kids_scan.vue?vue&type=template&id=52a7c6d5&scoped=true&"
import script from "./kids_scan.vue?vue&type=script&lang=js&"
export * from "./kids_scan.vue?vue&type=script&lang=js&"
import style0 from "./kids_scan.vue?vue&type=style&index=0&id=52a7c6d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7c6d5",
  null
  
)

export default component.exports